import {
  authFetch, buildApiUrl 
} from '../../../lib/api-client';
import {
  recipesResponseSchema,
  type RecipesResponse,
  type RecipeFilters,
} from '../types';

/**
 * Fetch recipes with optional filters.
 */
export async function getRecipes(
  filters?: RecipeFilters
): Promise<RecipesResponse> {
  const params = new URLSearchParams();

  if (filters?.type) {
    params.set('type', filters.type);
  }
  if (filters?.search) {
    params.set('search', filters.search);
  }
  if (filters?.allergen) {
    params.set('allergen', filters.allergen);
  }
  if (filters?.dietaryFlag) {
    params.set('dietaryFlag', filters.dietaryFlag);
  }
  if (filters?.limit) {
    params.set('limit', String(filters.limit));
  }

  const url = buildApiUrl('/v1/recipes', params);
  const response = await authFetch(url);

  if (!response.ok) {
    throw new RecipesApiError(
      response.status,
      `Failed to fetch recipes: ${response.statusText}`
    );
  }

  const data: unknown = await response.json();
  return recipesResponseSchema.parse(data);
}

export class RecipesApiError extends Error {
  constructor(
    public readonly statusCode: number,
    message: string
  ) {
    super(message);
    this.name = 'RecipesApiError';
  }
}
